import React from 'react';
import { Card, Typography, Space } from 'antd';
import { LEGAL_PAGE_CONTENT, LegalSection } from '../../data/legalPages';

const { Title, Paragraph } = Typography;

interface LegalInfoPageProps {
  section: LegalSection;
}

const LegalInfoPage: React.FC<LegalInfoPageProps> = ({ section }) => {
  const { title, paragraphs } = LEGAL_PAGE_CONTENT[section];
  return (
    <div className="app-page">
      <div className="app-container" style={{ maxWidth: 1000 }}>
        <Card className="app-content-card">
          <Title level={2}>{title}</Title>
          <Space direction="vertical" size="middle">
            {paragraphs.map((text, index) => (
              <Paragraph key={index} style={{ marginBottom: 0, whiteSpace: 'pre-wrap' }}>
                {text}
              </Paragraph>
            ))}
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default LegalInfoPage;
